const mutations = {
  pendingInvitelist: (state, value) => {
    state.pendingInvitelist = value
  },
  recrInfo: (state, value) => {
    state.recrInfo = value
  },
  recruiterCompL: (state, value) => {
    state.recruiterCompL = value
  },
  recruiterL: (state, value) => {
    state.recruiterL = value
  },
  sendMail: (state, payload) => {
    state.isContacted = payload
  }
}
export default mutations
